import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

/* Full-bleed, dimmed background photo with parallax + dark gradient veil */
export const SectionBg = ({ src, opacity = 0.22, position = "center", testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <div ref={ref} data-testid={testid} aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.img
        src={src}
        alt=""
        style={{ y, opacity, objectPosition: position }}
        className="absolute inset-0 h-[116%] w-full object-cover -top-[8%] grayscale-[35%]"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/55 to-ink" />
    </div>
  );
};
